import React from 'react';

import Price from '../price';

import { IPriceAndQuantityProps } from './types';

export const PriceAndQuantity: React.FC<IPriceAndQuantityProps> = ({
  item,
  offer,
  rewardApplied,
}) => <Price item={item} isOffer={!!offer} rewardApplied={rewardApplied} />;
